import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getEstaciones,
  deleteEstacion,
  getEstacionById,
} from "../helpers/rutaEstaciones";
import ModalEstacion from "./ModalEstacion";
import "../css/tableclientes.css";

const TableEstaciones = () => {
  const [estaciones, setEstaciones] = useState({
    data: {},
    loading: true,
  });

  const [estacion, setEstacion] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaEstaciones();
  }, []);

  const consultaEstaciones = () => {
    getEstaciones().then((datos) => {
      console.log("📦 Estaciones:", datos);
      setEstaciones({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaEstaciones();
  };

  const handleShow = () => setShow(true);

  const modificaEstacion = (id) => {
    getEstacionById(id).then((resp) => {
      if (resp.ok) {
        setEstacion(resp.estacion); // ✅ ahora sí solo el objeto estacion
        handleShow();
      } else {
        console.error("❌ Error al obtener estacion:", resp.error);
      }
    });
  };

  const eliminarEstacion = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar la estacion?");
    if (confirmar) {
      deleteEstacion(id).then(() => {
        consultaEstaciones();
      });
    }
  };

  return (
    <div className="table-container">
      {!estaciones.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Estacion</th>
                  <th className="dom">Lugar</th>
                </tr>
              </thead>
              <tbody>
                {estaciones.data.estaciones.map((estacion) =>
                  estacion.activo ? (
                    <tr key={estacion._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaEstacion(estacion._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarEstacion(estacion._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{estacion.codest}</td>
                      <td>{estacion.estacion}</td>
                      <td>{estacion.lugar}</td>
                      {/* <td>{estacion.localidad?.localidad || "-"}</td> */}
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalEstacion
            show={show}
            handleClose={handleClose}
            estacion={estacion}
          />
        </>
      )}
    </div>
  );
};

export default TableEstaciones;
